<div id="page-container">
  <div id="content-wrap">
    <app-header />
    <main>
      <router-outlet />
    </main>
  </div>
  <app-footer id="footer" />
</div>

<app-modal></app-modal>
